// Expand only the copies in the server's current truck page. The source's
// authoritative quantity stays intact for pricing and project totals.
export function prepareFleetPreview(items, trailer3d, limit = 100) {
  const prepared = []
  for (const item of items) {
    if (!item.render_scene || prepared.length >= limit) continue
    const renderState = trailer3d.buildTrailerRenderState(item.render_scene, {
      stretchMode: 'closed', renderOverrides: item.render_overrides,
    })
    const footprint = trailer3d.getTrailerRenderFootprint(renderState)
    const length = Number(footprint.maxX_in) - Number(footprint.minX_in)
    if (!(Number.isFinite(length) && length > 0 && Number.isFinite(Number(footprint.width_in)) && Number(footprint.width_in) > 0)) continue
    const count = Math.min(Math.max(0, Math.floor(Number(item.preview_truck_count) || 0)), limit - prepared.length)
    const offset = Number(item.preview_truck_offset) || 0
    for (let index = 0; index < count; index += 1) {
      prepared.push({
        ...item, key: `${item.key}:copy:${offset + index}`, sourceKey: item.key,
        label: item.preview_label, renderState, footprint,
      })
    }
  }

  const gap = 144
  const width = Math.max(0, ...prepared.map(item => Number(item.footprint.maxX_in) - Number(item.footprint.minX_in)))
  const area = prepared.reduce((sum, item) => sum + (Number(item.footprint.maxX_in) - Number(item.footprint.minX_in) + gap) * (Number(item.footprint.width_in) + gap), 0)
  const rowWidth = Math.max(width, Math.sqrt(area) * 1.15)
  let x = 0, z = 0, rowDepth = 0, maxX = 0
  const positioned = prepared.map(item => {
    const length = Number(item.footprint.maxX_in) - Number(item.footprint.minX_in)
    const depth = Number(item.footprint.width_in)
    if (x > 0 && x + length > rowWidth) {
      x = 0
      z += rowDepth + gap
      rowDepth = 0
    }
    const result = { ...item, worldOffset_in: { x_in: x - Number(item.footprint.minX_in), z_in: z + depth / 2 } }
    maxX = Math.max(maxX, x + length)
    x += length + gap
    rowDepth = Math.max(rowDepth, depth)
    return result
  })
  const centerZ = (z + rowDepth) / 2
  return positioned.map(item => ({ ...item, worldOffset_in: {
    x_in: item.worldOffset_in.x_in - maxX / 2, z_in: item.worldOffset_in.z_in - centerZ,
  } }))
}
